import $ from 'jquery';
import {tns} from 'tiny-slider/src/tiny-slider';
import 'tiny-slider/src/tiny-slider.scss';
import AOS from "aos";

$(document).ready(function() {
    $('.logosCarousel').each(function(index, element) {
        const $element = $(element);
        const $container = $element.find('[class*="__slides"]');
        tns({
            container: $container[0],
            loop: true,
            gutter: 16,
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayHoverPause: true,
            autoplayTimeout: 4000,
            nav: true,
            navPosition: 'bottom',
            controls: true,
            controlsPosition: 'top',
            controlsText: ['', ''],
            responsive: {
                0: {
                    items: 2
                },
                640: {
                    items: 3
                },
                960: {
                    items: 4
                },
                1260: {
                    items: 5
                },
                1400: {
                    items: 6
                }
            },
            onInit: function() {
                AOS.refresh();
            }
        });
    });
});